import React from "react";
import { Box, Typography, TextField, Button } from "@mui/material";

interface FilterInputsProps {
  title: string;
  setTitle: (value: string) => void;
  createdFrom: string;
  setCreatedFrom: (value: string) => void;
  createdTill: string;
  setCreatedTill: (value: string) => void;
  updatedFrom: string;
  setUpdatedFrom: (value: string) => void;
  updatedTill: string;
  setUpdatedTill: (value: string) => void;
  handleApplyFilter: () => void;
  handleClearFilter: () => void;
}

const FilterInputs: React.FC<FilterInputsProps> = ({
  title,
  setTitle,
  createdFrom,
  setCreatedFrom,
  createdTill,
  setCreatedTill,
  updatedFrom,
  setUpdatedFrom,
  updatedTill,
  setUpdatedTill,
  handleApplyFilter,
  handleClearFilter,
}) => {
  return (
    <Box display="flex" flexDirection="column" height="100%">
      {/* Scrollable content */}
      <Box flex={1} overflow="auto" p={2}>
        <Typography variant="h6" gutterBottom>
          Filter Exam Paper
        </Typography>

        {/* Title */}
        <TextField
          fullWidth
          label="Title"
          variant="outlined"
          margin="normal"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />

        <TextField
          fullWidth
          label="Created From"
          type="datetime-local"
          variant="outlined"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={createdFrom}
          onChange={(e) => setCreatedFrom(e.target.value)}
        />

        <TextField
          fullWidth
          label="Created Till"
          type="datetime-local"
          variant="outlined"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={createdTill}
          onChange={(e) => setCreatedTill(e.target.value)}
        />

        <TextField
          fullWidth
          label="Updated From"
          type="datetime-local"
          variant="outlined"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={updatedFrom}
          onChange={(e) => setUpdatedFrom(e.target.value)}
        />

        <TextField
          fullWidth
          label="Updated Till"
          type="datetime-local"
          variant="outlined"
          margin="normal"
          InputLabelProps={{ shrink: true }}
          value={updatedTill}
          onChange={(e) => setUpdatedTill(e.target.value)}
        />
      </Box>

      <Box
        position="sticky"
        bottom={0}
        p={2}
        borderTop="1px solid #ddd"
        bgcolor="white"
        zIndex={1}
        gap={2}
      >
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={handleApplyFilter}
          sx={{ mb: 1 }}
        >
          Apply Filters
        </Button>
        <Button
          variant="outlined"
          color="secondary"
          fullWidth
          onClick={handleClearFilter}
        >
          Clear Filters
        </Button>
      </Box>
    </Box>
  );
};

export default FilterInputs;
